import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useDocumentStore } from '@/store/documentStore';
import type { MapSettings } from '@/model/types';

const LAYOUT_OPTIONS: Array<{ value: MapSettings['layoutType']; labelKey: string }> = [
  { value: 'horizontal-tree', labelKey: 'layout.horizontalTree' },
  { value: 'radial', labelKey: 'layout.radial' },
  { value: 'vertical-tree', labelKey: 'layout.verticalTree' },
];

export function LayoutPicker() {
  const { t } = useTranslation();
  const settings = useDocumentStore((s) => s.settings);
  const mapDoc = useDocumentStore((s) => s.mapDoc);

  const handleChange = useCallback(
    (e: React.ChangeEvent<HTMLSelectElement>) => {
      const layoutType = e.target.value as MapSettings['layoutType'];
      mapDoc.updateSettings({ layoutType });
    },
    [mapDoc],
  );

  return (
    <select
      value={settings.layoutType}
      onChange={handleChange}
      title={t('layout.title')}
      style={{
        background: 'var(--bg-surface-raised)',
        color: 'var(--text-primary)',
        border: '1px solid var(--border-strong)',
        borderRadius: 6,
        padding: '6px 12px',
        cursor: 'pointer',
        fontSize: 'var(--font-size-sm)',
        fontFamily: 'var(--font-family)',
        appearance: 'auto',
      }}
    >
      {LAYOUT_OPTIONS.map((opt) => (
        <option key={opt.value} value={opt.value}>
          {t(opt.labelKey)}
        </option>
      ))}
    </select>
  );
}
